module.exports = __webpack_public_path__ + "img/hr-straight-rail-horizontal-backplates-remnants.cd77d3c4.png";